import React, {
  FC,
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useState,
} from "react"
import { historyHeat } from "@api/report"

/**
 * LayerHeat
 * @param param0
 */
const LayerHeat: FC<any> = ({ map, visible }) => {
  const refTimer = useRef<any>()
  const [data, setData] = useState<any>()
  const [heatMap, setHeatMap] = useState<any>()
  const getData = useCallback(async () => {
    let res = await historyHeat()
    setData(res)
  }, [])

  const interValGetData = useCallback(() => {
    if (refTimer.current) {
      clearInterval(refTimer.current)
    }
    refTimer.current = setInterval(getData, 10000)
  }, [getData])

  useMemo(() => {
    let heatData = []
    let max = 2
    if (!visible) {
      heatMap && heatMap.hide()
      return
    }
    if (data && data.points) {
      data.points.forEach((p) => {
        let coord = p.coordinates
        heatData.push({
          lng: coord[0],
          lat: coord[1],
          count: p.count,
        })
        max = Math.max(max, p.count)
      })
    }

    if (heatMap) {
      heatMap.show()
      heatMap.setDataSet({
        data: heatData,
        max: max,
      })
    }
  }, [data, heatMap, visible])
  useEffect(() => {
    getData()
    var heatmap
    map &&
      map.plugin(["AMap.Heatmap"], function () {
        //初始化heatmap对象
        heatmap = new window.AMap.Heatmap(map, {
          radius: 20, //给定半径
          opacity: [0, 0.8],
          zIndex: 120,
          zoom: [10, 20],
        })
        setHeatMap(heatmap)
        // interValGetData()
      })
    // getData()
    return () => {
      try {
        heatmap && heatmap.setMap(null)
      } catch (error) {}
    }
  }, [map, getData])

  return null
}

export default LayerHeat
